import React,{ Component } from 'react';
import './App.css';
import './components/SimpleMap';
import SimpleMap from './components/SimpleMap';
import Footer from './components/Footer';
import Header from './components/Header';
import SearchService from './services/SearchService';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";
import { ai } from './services/TelemetryService';

const browserHistory = createBrowserHistory({ basename: '' });
ai.initialize({ history: browserHistory });

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      heatMapItems: [],
      service: new SearchService(),
      selectedItem: null,
      footerDisplayItem: ""
    };
    this.updateMapPoints = this.updateMapPoints.bind(this);
    this.getLocation = this.getLocation.bind(this);
    this.setSelectedPhoto = this.setSelectedPhoto.bind(this);
    this.unsetPhoto = this.unsetPhoto.bind(this);
    this.updateHeatMapPoints = this.updateHeatMapPoints.bind(this);
    this.setToggle = this.setToggle.bind(this);
  }
  photoIds = []
  heatMapIds = []

  componentDidMount() {
    let current = this;
    current.state.service.search()
      .then(function(data) {
        current.updateMapPoints(data);
        current.updateHeatMapPoints(data);
      });
  }

  updateMapPoints(data){
    var photosToAdd = [];
    data.photos.forEach((photo) => {
      if(this.photoIds.indexOf(photo.id) === -1)
      {
        this.photoIds.push(photo.id);
        photosToAdd.push(photo);
      }
    })
    

    this.setState({
      items: this.state.items.concat(photosToAdd)
    });
  }

  updateHeatMapPoints(data){
    var bob = [];
    data.heatMapPoints.forEach((photo) => {
      if(this.heatMapIds.indexOf(photo.id) === -1)
      {
        this.heatMapIds.push(photo.id);
        bob.push(photo);
      }
    })
    

    this.setState({
      heatMapItems: this.state.heatMapItems.concat(bob)
    });
  }

  getLocation(location){
    ai.appInsights.trackEvent({name: "MapMove", properties: {"location": location }})
    let current = this;
    current.state.service.searchWithBounds(location)
    .then(function(data) {
      current.updateMapPoints(data);
      current.updateHeatMapPoints(data);
    });
  }

  setSelectedPhoto(event){
    if(this.state.selectedItem !== null && this.state.selectedItem.id === event.target.options.id){
      this.setState({
        selectedItem: null,
        footerDisplayItem: ""
      });
      return;
    }
    
    this.state.items.forEach((item) => {
      if(item.id === event.target.options.id){
        ai.appInsights.trackEvent({name: "SelectPhoto", properties: {"photo": item }})
        this.setState({
          selectedItem: item,
          footerDisplayItem: "photo"
        });
      }
    })
    
  }
  unsetPhoto(event){
    this.setState({
      selectedItem: null,
      footerDisplayItem: ""
    });
  }
  setToggle(displayItem){
    ai.appInsights.trackEvent({name: "ToggleCard", properties: {"name": displayItem }})
    this.setState({
      footerDisplayItem: displayItem
    })
  }

  render(){
    return (
      <div className="App">
        <SimpleMap unselectPhoto={this.unsetPhoto} selectPhoto={this.setSelectedPhoto} getCurrentBounds={this.getLocation} heatMapPoints={this.state.heatMapItems} items={this.state.items}/>
        <Footer setToggle={this.setToggle} displayToggle={this.state.footerDisplayItem} selectedPhoto={this.state.selectedItem} parentMethod={this.updateMapPoints} searchService={this.state.service} />
      </div>
    );
  } 
}

export default withAITracking(ai, App);